import script from "./PlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__